export const RAF_STATE = {
  PENDING: 1,
  DOES_NOT_QUALIFY: 2,
  APPROVED: 3,
  DNQ_PRIOR_YEAR_CLIENT: 4,
  PAID: 10,
};

const _RAF_DESCRIPTION_MAP = {};
_RAF_DESCRIPTION_MAP[RAF_STATE.PENDING] = 'Pending';
_RAF_DESCRIPTION_MAP[RAF_STATE.DOES_NOT_QUALIFY] = 'Does not Qualify';
_RAF_DESCRIPTION_MAP[RAF_STATE.APPROVED] = 'Approved';
_RAF_DESCRIPTION_MAP[RAF_STATE.DNQ_PRIOR_YEAR_CLIENT] = 'DNQ Prior Year Client';
_RAF_DESCRIPTION_MAP[RAF_STATE.PAID] = 'Paid';

export const RAF_DESCRIPTION_MAP = _RAF_DESCRIPTION_MAP;
